<template>
   <div>

      <!-- skeleton -->
      <section
         v-if="loading"
         class="bike-presentation bg-dark pt-0 pt-sm-4 skeleton"
      >
         <b-container class="p-0 pl-md-3 pr-md-3">
            <b-row
               align-v="center"
               no-gutters class="p-card p-0 p-relative row-bike"
            >
               <!-- Carousel Bike | Seleção de Fotos da Bicicleta -->
               <b-col lg="6" xl="7" class="h-100 carousel-bike">
                  <b-skeleton-img card-img="left" height="100%"></b-skeleton-img>
               </b-col>

               <b-col lg="6" xl="5" order="2" order-lg="0" class="align-content-between bg-white info-bike d-flex justify-content-between h-100 flex-column">
                  <div class="pl-3 pr-3 pt-3 pl-sm-4 pr-sm-4 text-center text-sm-left">
                     <b-skeleton animation="wave" width="85%" height="30px"></b-skeleton>

                     <b-skeleton class="mt-3" animation="wave" width="45%" height="10px"></b-skeleton>
                     <b-skeleton class="mt-2" animation="wave" width="20%" height="12px"></b-skeleton>
                     <b-skeleton class="mt-4 mb-5" animation="wave" width="15%" height="10px"></b-skeleton>
                     <b-skeleton class="mt-5 mr-auto ml-auto" animation="wave" width="50%" height="10px"></b-skeleton>
                     <b-skeleton class="mt-2 mr-auto ml-auto" animation="wave" width="30%" height="10px"></b-skeleton>
                     <b-skeleton class="mt-2 mr-auto ml-auto" animation="wave" width="60%" height="10px"></b-skeleton>
                     <br><br>
                     <b-skeleton class="mt-3" animation="wave" width="100%" height="40px"></b-skeleton>
                     <b-skeleton class="mt-4 mr-auto ml-auto" animation="wave" width="80%"
                                 height="40px"></b-skeleton>
                  </div>
               </b-col>
            </b-row>
         </b-container>
      </section>

      <section v-if="loading" class="bike-description bg-dark pt-4 pb-5 text-center text-lg-left">

         <b-container>
            <b-row>
               <b-col lg="9" class="pr-md-5">
                  <b-skeleton animation="wave" width="45%" height="12px"></b-skeleton>
                  <b-skeleton class="mt-3" animation="wave" width="75%" height="10px"></b-skeleton>
                  <b-skeleton class="mt-2" animation="wave" width="66%" height="10px"></b-skeleton>
                  <b-skeleton class="mt-2" animation="wave" width="50%" height="10px"></b-skeleton>
                  <b-skeleton class="mt-5" animation="wave" width="30%" height="10px"></b-skeleton>
                  <b-skeleton class="mt-2" animation="wave" width="66%" height="10px"></b-skeleton>
                  <b-skeleton class="mt-2" animation="wave" width="50%" height="10px"></b-skeleton>
               </b-col>
               <b-col>
                  <div class="p-card p-5 user-block mt-4 mt-md-0 text-center">
                     <b-skeleton class="m-auto" lg="3" type="avatar" height="70px" width="70px"></b-skeleton>
                     <b-skeleton class="mt-3 ml-auto mr-auto" animation="wave" width="85%" height="10px"></b-skeleton>
                  </div>
               </b-col>
            </b-row>
         </b-container>
      </section>

      <!-- fim skeleton -->

      <!-- ======== Carousel Card Bike | Cabeçalho da página Bicicleta, com slider e informações como nome, preço, avaliação e calendário ======== -->
      <section v-if="!loading" class="bike-presentation bg-dark pt-0 pt-sm-4">
         <b-container class="p-0 pl-md-3 pr-md-3">
            <el-alert
               style="line-height: 11px"
               class="mb-3"
               v-if="bike.info.status === 1"
               title="BICICLETA EM ANÁLISE!"
               description="Esta bicicleta ainda não está visível ao público, pois está em processo de Análise. Você será notificado por e-mail assim que aprovarmos. A publicação será automatica!"
               type="warning"
               show-icon>
            </el-alert>

            <el-alert
               style="line-height: 11px"
               class="mb-3"
               v-if="bike.info.status === 4"
               title="BICICLETA REPROVADA!"
               description="Esta bicicleta não está visível ao público, pois foi REPROVADA. Por favor, verifique se você preencheu as informações corretas da sua bike. Edite ela novamente."
               type="error"
               show-icon>
            </el-alert>

            <b-row
               align-v="center"
               no-gutters class="p-card p-0 p-relative row-bike"
               v-loading="loadingOrderFronModalInfo"
               element-loading-text="Processando pedido, por favor, aguarde..."
            >
               <!-- Carousel Bike | Seleção de Fotos da Bicicleta -->
               <b-col lg="6" xl="7" class="h-100 carousel-bike">
                  <el-carousel class="h-100">
                     <el-carousel-item v-for="image in bikePhotos" :key="image">
                        <div class="thumb-bike bg-center bg-cover"
                             :style="{backgroundImage : `url(${image})`}"></div>
                     </el-carousel-item>
                  </el-carousel>
               </b-col>

               <!-- Card Info Bik | Cartão com Informações da Bicicleta -->
               <b-col lg="6" xl="5" order="2" order-lg="0" class="align-content-between bg-white info-bike d-flex justify-content-between h-100 flex-column">
                  <div class="pl-3 pr-3 pt-3 pl-sm-4 pr-sm-4 text-center text-sm-left">
                        <!--  Informações de título e local -->
                        <div class="text-center">
                           <h1 class="h4 font-strong mb-0">{{ bike.info.name }}</h1>
                           <div class="city mt-1"> <i class="el-icon-location-outline mr-1"></i>
                              <span v-if="bike.address.city">{{bike.address.neighborhood}} , {{bike.address.city}}, {{bike.address.state}}</span>
                              <span v-if="!bike.address.city">{{bike.address.name}}</span>
                           </div>

                           <hr>

                           <!-- El Rate | Avaliação -->
                           <div class="rate mb-2" v-if="false">
                              <el-rate
                                 v-model="bike.info.rateMetrics.averageRating"
                                 disabled
                                 show-score
                                 text-color="#ff9900"
                                 score-template="{value}">
                              </el-rate>
                           </div>

                           <el-alert
                              v-if="selectDatesQuery.dateCheckout && selectDatesQuery.dateCheckin === selectDatesQuery.dateCheckout"
                              class="mt-2 mb-4"
                              type="error"
                              effect="dark"
                              :closable="false"
                              show-icon>
                              <template slot="title">
                                 <strong style="line-height: 2;">
                                    ATENÇÃO: A data de <u>entrega</u> não pode ser a mesma data de <u>busca</u>!
                                    Selecione
                                    novamente:
                                 </strong>
                              </template>
                           </el-alert>

                           <el-alert
                              v-if="selectDatesQuery.dateCheckout && selectDatesQuery.dateCheckout < selectDatesQuery.dateCheckin"
                              class="mt-2 mb-4"
                              type="error"
                              effect="dark"
                              :closable="false"
                              show-icon>
                              <template slot="title">
                                 <strong style="line-height: 2;">
                                    SELEÇÃO INVÁLIDA: A data de <u>entrega</u> precisa ser posterior a data de
                                    <u>busca</u>!
                                    Selecione novamente:
                                 </strong>
                              </template>
                           </el-alert>
                        </div>

                        <!--  Seleção de Modalidade da locação: Sob-demanda (onDemand) ou Assinatura (signature)  -->
                        <div class="text-center">
                           <h6 class="mt-1 font-strong">Eu quero:</h6>
                           <el-radio
                              :disabled="bike.info.timeValue === 0
                              && bike.info.dailyValue === 0
                              || loadinBtnCheckout"
                              v-model="leaseModality" label="onDemand" border class="mr-0">
                              <strong>pedir a bike</strong>
                           </el-radio>
                           <el-radio
                              :disabled="!bike.info.monthValue && !bike.info.weekValue ||
                              bike.info.monthValue === 0
                              && bike.info.weekValue === 0
                              || loadinBtnCheckout"
                              v-model="leaseModality" label="signature" border class="mr-0"><strong>assinar a
                              bike</strong>
                           </el-radio>
                        </div>

                        <!--  Seleção de Opções de locação: Mês, semana, dia ou hora -->
                        <div  class="text-center mt-1">
                           <h6 v-if="leaseModality" class="font-strong">
                              <span v-if="leaseModality === 'onDemand'">para pedalar por:</span>
                              <span v-if="leaseModality === 'signature'">por:</span>
                           </h6>
                              <!--  Por hora ou por dia -->
                           <span v-if="leaseModality === 'onDemand'">
                              <el-radio
                                 :disabled="!bike.info.timeValue || bike.info.timeValue === 0 || loadinBtnCheckout"
                                 v-model="typeOfLeasePeriod"
                                 label="perHour"
                                 border
                                 class="mr-0"
                              ><strong>hora</strong><span v-if="bike.info.timeValue !== 0"> (R${{ bike.info.timeValue }})</span>
                              </el-radio>
                              <el-radio
                                 :disabled="bike.info.dailyValue === 0 || loadinBtnCheckout"
                                 v-model="typeOfLeasePeriod"
                                 label="daily"
                                 border
                              ><strong>dia</strong> <span v-if="bike.info.dailyValue !== 0"> (R${{ bike.info.dailyValue }})</span>
                              </el-radio>
                           </span>

                           <!--  Por semana ou por mês  -->
                           <span v-if="leaseModality === 'signature'">
                               <el-radio
                                  :disabled="!bike.info.weekValue || bike.info.weekValue === 0 || loadinBtnCheckout"
                                  v-model="typeOfLeasePeriod"
                                  label="perWeek"
                                  border
                                  class="mr-0">
                                    <strong>semana</strong><span v-if="bike.info.weekValue !== 0"> (R${{bike.info.weekValue}})</span>
                               </el-radio>
                               <el-radio
                                  :disabled="!bike.info.monthValue || bike.info.monthValue === 0 || loadinBtnCheckout"
                                  v-model="typeOfLeasePeriod"
                                  label="monthly"
                                  border
                                  class="mr-0">
                                  <strong>mês</strong> <span v-if="bike.info.monthValue !== 0"> (R${{bike.info.monthValue}})</span>
                               </el-radio>
                           </span>

                        </div>

                        <!--  Locação por mês -->
                        <div>
                           <div class="mt-1 input-number-select"
                                :class="[numberOfMonthsOfLease > 1 ? 'plural' : '', numberOfMonthsOfLease > 9 ? 'decimal' : '']"
                                v-if="typeOfLeasePeriod === 'monthly' && leaseModality === 'signature'">
                              <div class="w-100 text-center text-primary font-strong mb-2">e quero ficar com ela por:
                              </div>
                              <div class="d-flex justify-content-center">
                                 <el-input-number
                                    :disabled="loadinBtnCheckout"
                                    style="width: 180px"
                                    :min="1" :max="12"
                                    v-model="numberOfMonthsOfLease"
                                    @change="changeLeasePerMonth"
                                 ></el-input-number>
                                 <span class="input-number__badge month">{{ numberOfMonthsOfLease > 1 ? `meses` : `mês` }}</span>
                              </div>
                           </div>

                           <!--  Locação por semana -->
                           <div class="mt-1 input-number-select per-week"
                                :class="[numberOfRentalWeeks > 1 ? 'plural' : '', numberOfRentalWeeks > 9 ? 'decimal' : '']"
                                v-if="typeOfLeasePeriod === 'perWeek' && leaseModality === 'signature'">
                              <div class="w-100 text-center text-primary font-strong mb-2">e quero ficar com ela por:
                              </div>
                              <div class="d-flex justify-content-center">
                                 <el-input-number
                                    :disabled="loadinBtnCheckout"
                                    style="width: 200px"
                                    :min="1"
                                    :max="52"
                                    v-model="numberOfRentalWeeks"
                                    @change="changeRentalPerWeek"
                                 ></el-input-number>
                                 <span
                                    class="input-number__badge week">{{ numberOfRentalWeeks > 1 ? 'semanas' : 'semana' }}</span>
                              </div>
                           </div>

                           <!--  Locação por dia -->
                           <div class="mt-1" v-if="typeOfLeasePeriod === 'daily' && leaseModality === 'onDemand'">
                              <SelectDates
                                 :disabled="loadinBtnCheckout"
                                 ref="selectDates"
                                 title="nas seguintes datas"
                                 :dataBike="bike"
                              />
                           </div>

                           <!-- Locação por hora -->
                           <div v-if="typeOfLeasePeriod === 'perHour' && leaseModality === 'onDemand'" class="time-select-range">
                              <div class="w-100 text-center text-primary font-strong mt-2 mb-2">
                                 da seguinte forma:
                              </div>
                              <b-row no-gutters>
                                 <b-col lg="6" class="pr-0 mb-0 pr-lg-1">
                                    <el-date-picker
                                       format="dd-MM-yyyy"
                                       :disabled="loadinBtnCheckout"
                                       class="w-100 mb-2 mb-lg-0"
                                       v-model="daySelectedForHourlyRental"
                                       type="date"
                                       placeholder="Selecione o dia da pedalada"
                                       @change="hangleChangeDaySelectedForHourlyRental"
                                       :picker-options="pickerOptions2"
                                       >
                                    </el-date-picker>
                                 </b-col>
                                 <b-col cols="6" lg="3" class="pr-2 mb-0 pr-md-1">
                                    <el-time-select
                                       :disabled="loadinBtnCheckout"
                                       class="w-100 mb-0"
                                       placeholder="das"
                                       v-model="startHourRental"
                                       @change="hangleChangeStartHourRental"
                                       :picker-options="{
                                          start: '08:30',
                                          step: '00:30',
                                          end: '18:30'
                                    }"
                                    >
                                    </el-time-select>
                                 </b-col>
                                 <b-col cols="6" lg="3" class="mb-0">
                                    <el-time-select
                                       :disabled="loadinBtnCheckout"
                                       class="w-100"
                                       placeholder="às"
                                       v-model="endHourRental"
                                       @change="hangleChangeEndHourRental"
                                       :picker-options="{
                                          start: '08:30',
                                          step: '00:30',
                                          end: '18:30',
                                          minTime: startHourRental
                                          }"
                                    >
                                    </el-time-select>
                                 </b-col>
                              </b-row>


                           </div>

                        </div>

                        <!--  Locação por mês -->
                        <div v-if="leaseTypeStages === 3">
                           <div class="w-100 text-center text-primary font-strong mb-2">Para finalizar, escolha os equipamentos:
                           </div>
                           <el-form ref="form" :model="form" :inline="false" size="mini">
                              <el-form-item class="mb-2">
                                 <el-checkbox-group v-model="form.type" :disabled="loadinBtnCheckout">
                                    <el-checkbox label="Capacete (R$25)" name="type"></el-checkbox>
                                    <el-checkbox label="Garraginha de água (R$5)" name="type"></el-checkbox>
                                    <el-checkbox label="Luvas (R$3)" name="type"></el-checkbox>
                                    <el-checkbox label="Óculos (R$18)" name="type"></el-checkbox>
                                    <el-checkbox label="Delivery (R$ 50)" name="type"></el-checkbox>
                                 </el-checkbox-group>
                              </el-form-item>
                              <el-form-item class="mb-0">
                                 <el-input
                                    :disabled="loadinBtnCheckout"
                                    placeholder="Observação extra:"
                                    type="textarea"
                                    v-model="form.desc
                                 "></el-input>
                              </el-form-item>
                           </el-form>
                        </div>

                        <!--  TOTAL por hora -->
                        <b-card-footer
                           v-if="typeOfLeasePeriod === 'perHour'
                           && timeNumber > 0
                           && leaseModality === 'onDemand'"
                           class="font-weight-bolder border-0 mt-2"
                        >
                           <span>{{timeNumber}} {{timeNumber > 1 ? 'horas' : 'hora'}}  X {{bike.info.timeValue  | currency }}/hora</span>
                           <span class="float-none float-md-right font-weight-bold d-block">TOTAL: {{ (timeNumber * bike.info.timeValue)  | currency }}</span>
                        </b-card-footer>


                        <!--  TOTAL por diária -->
                        <b-card-footer
                           v-if="typeOfLeasePeriod === 'daily'
                           && dailyNumberCalc > 0
                           && leaseModality === 'onDemand'"
                           class="font-weight-bold border-0 mt-2"
                        >
                           <span>{{dailyNumberCalc}} {{dailyNumberCalc > 1 ? 'diárias' : 'diária'}} X {{bike.info.dailyValue  | currency }}/dia</span>
                           <span class="float-none float-md-right font-weight-bold d-block">TOTAL: {{ (dailyNumberCalc * bike.info.dailyValue)  | currency }}</span>
                        </b-card-footer>

                        <!--  TOTAL por semana -->
                        <b-card-footer
                           v-if="typeOfLeasePeriod === 'perWeek'
                            && numberOfRentalWeeks > 0
                            && leaseModality === 'signature'"
                           class="font-weight-bold border-0 mt-2"
                        >
                           <span>{{numberOfRentalWeeks}} {{numberOfRentalWeeks > 1 ? 'semanas' : 'semana'}} X {{bike.info.weekValue  | currency }}/semana</span>
                           <span class="float-none float-md-right font-weight-bold d-block">TOTAL: {{ (bike.info.weekValue * numberOfRentalWeeks)  | currency }}</span>
                        </b-card-footer>

                        <!--  TOTAL por mês -->
                        <b-card-footer
                           v-if="typeOfLeasePeriod === 'monthly'
                           && numberOfMonthsOfLease > 0
                           && leaseModality === 'signature'"
                           class="font-weight-bold border-0 mt-2"
                        >
                           <span>{{numberOfMonthsOfLease}} {{numberOfMonthsOfLease > 1 ? 'meses' : 'mês'}} X {{bike.info.monthValue  | currency }}/mês</span>
                           <span class="float-none float-md-right font-weight-bold d-block">TOTAL: {{ (bike.info.monthValue * numberOfMonthsOfLease)  | currency }}</span>
                        </b-card-footer>

                        <!-- Button | Submit do formulário -->
                        <div class="text-center">
                           <el-button
                              icon="el-icon-chat-line-round"
                              @click="openChat(bike._id)"
                              size="medium"
                              type="secondary"
                              style="width: 100%; display: block; margin-bottom: 6px;"
                              class="d-inline mt-2 font-weight-bold mx-auto"
                              :loading="loadingBtChat"
                           >
                              Falar com o Anfitrião
                           </el-button>
                           <el-button
                              :disabled="!!!((timeNumber > 0 && daySelectedForHourlyRental && typeOfLeasePeriod === 'perHour' && leaseModality === 'onDemand')
                           || (dailyNumberCalc > 0 && typeOfLeasePeriod === 'daily'  && leaseModality === 'onDemand')
                           || (numberOfRentalWeeks >  0  && typeOfLeasePeriod === 'perWeek' && leaseModality === 'signature')
                           || (numberOfMonthsOfLease >  0  && typeOfLeasePeriod === 'monthly' && leaseModality === 'signature'))"
                              :loading="loadinBtnCheckout"
                              @click="goCheckout()"
                              size="medium"
                              type="primary"
                              style="width: 100%; display: block"
                              :class="`d-inline mt-2 font-weight-bold mx-auto`">
                              {{loadinBtnCheckout ? 'PROCESSANDO PEDIDO...' : 'SOLICITAR BICICLETA'}}
                           </el-button>
                        </div>
                  </div>
                  <div>
                     <el-alert
                        class="mt-2 pr-1 pl-3 justify-content-center"
                        type="info"
                        :closable="false"
                     >
                        <template slot="default">
                           <ul class="mt-1 mb-1 pl-3 text-dark text-left text-md-center list-unstyled" style="font-size: 14px;">
                              <li>Você poderá cancelar sem custos, se necessário;</li>
                              <li>Pague direto para o dono da bike.</li>
                           </ul>
                        </template>
                     </el-alert>
                  </div>

               </b-col>
            </b-row>
         </b-container>
      </section>

      <!-- ======== Description Bike | Descrição da Biciclta ======== -->
      <section v-if="!loading" class="bike-description bg-dark pt-4 pb-5 text-center text-lg-left">
         <b-container>
            <b-row>
               <b-col lg="8" class="pr-md-5">
                  <h6>Descrição</h6>
                  <div v-html="bike.info.description" class="lead text-justify mb-3"></div>

                  <!-- Features list | Lista de Recursos -->
                  <b-row class="features-list">
                     <b-col md="8" class="mb-2"><h6>Características</h6></b-col>
                     <b-col md="4" class="mb-2 order-1 order-md-0"><h6>Observações</h6></b-col>

                     <b-col md="8">
                        <ul class="row list-unstyled">
                           <li class="col-md-6" v-for="(feature, index) in getFeatures" :key="index">
                                        <span v-if="feature"><strong>{{ feature.name }}</strong>: {{
                                              feature.value
                                           }}</span>
                           </li>
                        </ul>
                     </b-col>

                     <b-col md="4" class="order-2 order-md-0">
                        <p v-if="bike.features.observation" class="">{{ bike.features.observation }}</p>
                        <p class="mb-0">Valor da Bicicleta: {{ bike.bikeValue | currency }}</p>
                     </b-col>

                  </b-row>
               </b-col>


               <!-- User Block Avatar | Bloco Avatar do Ciclista -->
               <b-col lg="4">
                  <div v-if="false" class="p-card pt-5 user-block mt-4 mt-md-0">
                     <div class="block mb-2">

                        <span v-if="user.additionalInformation">
                           <span v-if="user.additionalInformation.type === 'pj'" class="flag-business">
                              <img :src="businessMark" alt=""> EMPRESA
                           </span>
                        </span>

                        <el-image
                           :src="avatarUri"
                           fit="cover"
                           :lazy="false"
                           class="avatar"
                        >
                           <div slot="error" class="image-slot error">
                              <i class="el-icon-picture-outline"></i>
                           </div>
                        </el-image>
                     </div>
                     <h6 class="text-muted mb-0 mt-3">{{ user.firstName }} {{ user.lastName }}</h6>
                     <p class="small text-muted mt-2">{{ user.description }}</p>
                     <el-button
                        @click="() => handleGoAdviser(user._id)"
                        type="primary"
                        size="mini"
                     >
                        Ver bicicletas do anfitrião
                     </el-button>
                  </div>
                  <UserVerificationCard :userId="this.bike.user._id" showBtnBikes />
               </b-col>
            </b-row>
         </b-container>
      </section>

      <!-- ======== Available Dates and Map | Datas de Disponibilidade e Mapa ======== -->
      <section v-if="!loading" class="available-dates">
         <b-container v-loading="loading">
            <b-row class="pt-4">
               <!-- Calendar Dates Available | Calendário Dias Disponíveis -->
               <b-col lg="7">

                  <h5 class="text-white mt-4">Disponibilidade</h5>
                  <p class="text-white mb-4">Confira as datas de disponibilidade para locação</p>

                  <div class="p-card p-3">
                     <el-calendar
                        :first-day-of-week="0"
                        ref="bigCalendar"
                        id="available_dates_calendar"
                        class="available-dates-calendar small">
                        <template
                           slot="dateCell"
                           slot-scope="{date, data}">
                  <span :class="!availableDates.includes(data.day) ? 'is-available' : ''">
                    {{ data.day.split('-').slice(2).join() }} {{ !availableDates.includes(data.day) ? '️' : '' }}
                  </span>
                        </template>
                     </el-calendar>
                  </div>
               </b-col>
               <!-- Gmap Google Maps with API Connect | Gmap Google Maps com API Conectada -->
               <!-- TODO: A API do Google Maps é paga. Detalhes https://developers.google.com/maps/documentation/javascript/get-api-key . Para efeitos de desenvolvimento, foi utilizado a conta empresarial de Élisson Kario, com a versão de avaliação. Informações do Cloud Platform: Nome do projeto: Pedale. ID do projeto pedale-1573090148769
      -->
               <b-col lg="5" class="mt-lg-0">

                  <h5 class="text-white mt-4">Localização Aproximada</h5>
                  <p class="text-white mb-4">O local é fornecido após a reserva</p>

                  <div class="p-card p-3 block-map" v-if="center.lng">
                     <GmapMap
                        class="gmap-location"
                        :center="{ lat, lng}"
                        :zoom="14"
                        map-type-id="roadmap"
                        style="width: 100%; height: 100%"
                        :options="{
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: false,
                            disableDefaultUi: false
                 }"
                     >
                        <GmapCircle
                           v-for="(pin, index) in markers"
                           :key="index"
                           :center="pin.position"
                           :radius="1000"
                           :visible="true"
                           :options="{
                              fillColor:'#47b54c',
                              fillOpacity:0.2,
                              strokeColor: '#47b54c',
                              strokeOpacity: 0.8,
                           }"
                        ></GmapCircle>
                     </GmapMap>
                  </div>
               </b-col>
            </b-row>
            <b-row class="mt-4">
               <!-- Titles | Títulos -->
               <b-col lg="7">
                  <div class="text-muted"><small>A confirmação das datas, estão sujeitas a aprovação do
                     anfitrião da
                     bicicleta!</small></div>
               </b-col>
               <b-col lg="5">
                  <!-- TODO: Será preciso coletar o nome de forma dinâmica. -->
                  <div class="text-muted ">
                     <small class="font-weight-bold">
                        <v-icon name="map-marker-alt" class="mr-2"></v-icon>
                        <span v-if="bike.address.city">{{bike.address.neighborhood}} , {{bike.address.city}}, {{bike.address.state}}</span>
                        <span v-if="!bike.address.city">{{bike.address.name}}</span>
                    </small>
                  </div>
               </b-col>

               <b-col cols="12">
                  <el-button
                     @click="reportProblemAction(bike._id)"
                     size="small"
                     type="link"
                     class="mt-4 d-block font-weight-bold"
                     round>Denunciar este
                     anúncio
                  </el-button>
               </b-col>
            </b-row>
         </b-container>


      </section>

      <!-- ======== Comments | Comentários ======== -->
      <section  v-if="!loading" class="comments pt-5 pb-5 mb-5 mt-5 bg-light">
         <b-container v-loading="loading">

            <h5 class="mb-5">Avaliações</h5>
            <b-row>

               <b-col cols="12" v-if="!ratings.length">

                  <h6><i class="el-icon-star-off"></i> Essa bicicleta ainda não recebeu avaliações!</h6>

               </b-col>

               <b-col v-for="(rating, index) in ratings" :key="index" lg="4" class="user-comment mb-4">
                  <div class="bg-white p-3 rounded">
                     <h6>{{ rating.by.firstName }} {{ rating.by.lastName }}</h6>
                     <small>{{ formatDateChat(rating.createdAt) }}</small>
                     <el-rate
                        class="mt-2"
                        v-model="rating.rate"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}">
                     </el-rate>

                     <hr>

                     <p>{{ rating.comment }}</p>

                  </div>
               </b-col>

            </b-row>

            <div v-if="ratings.length" class="text-center mt-4">

               <el-button
                  :loading="loadingRatings"
                  @click="getMoreRatingsBike(bike ? bike._id : '')"
                  type="default"
                  :disabled="loadButtonNewComments"
               >Ver Mais
               </el-button>

            </div>
         </b-container>
      </section>

      <!-- ======== Call to Action | Chamada para Ação ======== -->
      <div v-if="!loading">
         <CallToActionSection
            class="mt-5"
            title="Quer alugar sua bicicleta?"
            desc="Veja como é rápido, prático e seguro alugar sua bicicleta."
            textLink="CLIQUE AQUI E ALUGUE AGORA MESMO"
            link="/registrar"

         />
      </div>

      <!-- Modal Login -->
      <div v-if="loginModal">
         <el-dialog
            top="2vh"
            class="modal-checkout login"
            :visible.sync="loginModal"
            :destroy-on-close="true"
            :close-on-press-escape="true"
            :before-close="closeModalLogin"
         >
            <div class="header-modal text-center">
               <h4>Acesse sua conta</h4>
            </div>
            <Login
               modal
               :namespace="namespace"
               @openModal="registerModal = true"
               @loginDone="loginDone"
            ></Login>

            <div class="text-center">
               <router-link to="/recuperar-senha">Esqueceu a senha?</router-link>
               <hr class="mt-3 pb-2 pb-sm-0 mb-3 mt-md-3 mb-md-3">
               <div class="text-muted mb-2 h6">Ainda não tem uma conta?</div>
               <el-button
                  type="secondary"
                  plain
                  class="mt-3 mt-md-3 mb-5 d-block w-75 m-auto font-weight-bold btn-login-register border"
                  round
                  style="border: 1px solid #4ab555 !important;"
                  @click="registerModal = true; loginModal = false"
               >
                  CADASTRE-SE
               </el-button>
            </div>

         </el-dialog>
      </div>

      <!-- Modal Registro -->
      <div v-if="registerModal">
         <el-dialog
            top="2vh"
            class="modal-checkout login register"
            :visible.sync="registerModal"
            :destroy-on-close="true"
            :close-on-press-escape="true"
            :before-close="closeModalRegister"
         >
            <div class="header-modal text-center">
               <h4>Registrar</h4>
            </div>
            <Register
               @registerDone="loginDone"
               modal
               :namespace="namespace"
            ></Register>

         </el-dialog>
      </div>

      <!--=== Chat Drawer / Gaveta do Chat ===-->
      <el-drawer
         custom-class="chat-pedale"
         :visible.sync="chat.open"
         :before-close="closeChat"
      >
         <div v-if="chat.open" class="h-100">
            <ChatContainer
               :isDrawer="true"
               showHeader
               class="h-100"
               :userId="userId"
               :refID="bike._id"
               :refData="{bike, user}"
               namespace="bike"
            >
            </ChatContainer>
         </div>

      </el-drawer>

      <!-- Modal Formulário de Informações do usuário e veficicação do telefone. -->
      <div v-if="checkoutModal">
         <el-dialog
            top="1rem"
            class="modal-pre-checkout modal-checkout custom-modal"
            :visible.sync="checkoutModal"
            :destroy-on-close="true"
            :close-on-press-escape="true"
            :before-close="closeModalRegister"
            close-on-click-modal
         >
         <Checkout
            :loggedInUserInformation="orderUserInformation"
            :selectedBike="bike"
            :isRequestedByOwner="isRequestedByOwner"
            @closeModal="v => closeModalPreCheckout(v)"
            @onCallBackIndo="v => handleCallBackInfoForm(v)"
         ></Checkout>

      </el-dialog>
      </div>

      <!-- Modal de confirmação de reserva. -->
      <div v-if="checkoutModalSuccess">
         <CheckoutModalSuccess
            :checkoutModalSuccess="checkoutModalSuccess"
            :isRequestedByOwner="isRequestedByOwner"
            :bike="bike"
            :successOrder="successOrder"
            :orderUserInformation="orderUserInformation"
            :typeOfLeasePeriod="typeOfLeasePeriod"
            :leaseModality="leaseModality"
         />
      </div>
   </div>
</template>

<script>
// @ is an alias to /src
import imgBike from '@/assets/img/bike.jpg';
import CallToActionSection from "../components/CallToActionSection";
import SiteService from '@/services/site.service';
import bike from '@/models/Bike';
import BikeImg from '@/helpers/GetBikeCover'
import SelectDates from '@/components/SelectDates'
import Login from '@/views/Login'
import Register from '@/views/Register'
import businessMark from "@/assets/img/business-mark.png";
import ChatContainer from "@/components/Chat";
import {dailyNumber, metaTags} from "@/helpers";
import Checkout from "@/views/Checkout";
import OrderService from '@/services/order.service';
import UserService from '@/services/user.service';
import CheckoutModalSuccess from '@/components/modals/CheckoutModalSuccess';
import {BCardFooter, BSkeletonImg, BSkeleton} from "bootstrap-vue";
import {timeNumber as calcTimeNumber} from "../helpers";
import UserVerificationCard from "@/components/UserVerificationCardV2";
export default {
   name: 'bike',
   metaInfo() {
      const bikeName = this.bike.info.name
      const bikeDesc = this.bike.info.description
      const bikeSlug = this.baseUrl + '/bicicleta/' + this.bike.info.slug

      return metaTags(bikeName, bikeDesc, bikeSlug, this.getCover(this.bike.photos.coverPhoto))

   },
   components: {
      CallToActionSection,
      SelectDates,
      Login,
      Register,
      Checkout,
      CheckoutModalSuccess,
      BCardFooter,
      BSkeleton,
      BSkeletonImg,
      ChatContainer,
      UserVerificationCard
   },
   directives: {
      'b-card-footer': BCardFooter,
      'b-skeleton': BSkeleton,
      'b-skeleton-img': BSkeletonImg,
   },
   data() {
      return {
         center: { lat: null, lng: null },
         markers: [
            { Id: null, name: "", position: { lat: null, lng: null } },
         ],
         availableDates: [],
         querySearch: this.searchQuery,
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         imgBike,
         user: {},
         bike,
         receivedData: false,
         ratings: [],
         loadButtonNewComments: false,
         bikeSlug: null,
         bikePhotos: [],
         avatarUri: '',
         lat: -13.6599108,
         lng: -69.6833154,
         loadinBtnCheckout: false,
         loading: true,
         loginModal: false,
         loadingBtChat: false,
         registerModal: false,
         loadingRatings: false,
         pagination: {
            total: 0,
            page: 1,
            perPage: 3
         },
         businessMark,
         chat: {
            open: false,
            bookObj: {}
         },
         userId: '',
         namespace: '',
         leaseModality: '', // onDemand (locação por dia ou hora) ou signature (locação por assinatura)
         typeOfLeasePeriod: '', // monthly (mês), perWeek (por semana), daily (por dia) ou perHour (por hora)
         daySelectedForHourlyRental: '', // dia da pedalada, para pedalada por hora
         startHourRental: '', // alugar das
         endHourRental: '', // até
         numberOfMonthsOfLease: 0, // número de meses
         numberOfRentalWeeks: 0, // número de semanas
         leaseTypeStages: 0,
         checkoutModal: false,
         form: {
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
         },
         pickerOptions2: {
            disabledDate(time) {
               return Date.now() - (3600 * 1000 * 24) > time.getTime() ;
            },
         },
         isRequestedByOwner: null,
         orderUserInformation: {
            _id: '',
            firstName: '',
            lastName: '',
            additionalInformation: {

            },
            address: {

            },
            pushToken: ''
         },
         checkoutModalSuccess: false,
         successOrder: {
            amount: 0,
            orderN: 0,
         },
         loadingOrderFronModalInfo: false,
         hostDate: {}
      };
   },
   async mounted() {

      this.bikeSlug = (this.$route.params.slug ? this.$route.params.slug : null);

      //Usado para pegar o ano e mês do calendário de Disponibilidade a fim de ser alterado para Mes - Ano em watch titleCalendar
      let fakeHeaderCalendarDates = document.createElement("span")
      fakeHeaderCalendarDates.className = "fake-header-calendar"

      // Usado para limpar as datas, ao abrir a bike.
      this.$store.dispatch('selectDates/clearDates');

   },
   updated() {
      const isOwner = this.currentUser.user._id === this.bike.user._id
      if (isOwner) {
         this.isRequestedByOwner = true
      }
   },
   methods: {

      async closeChat() {
         this.chat.open = false
      },

      async openChat() {
         this.namespace = 'bike/chat'
         if (!this.currentUser) {
            this.loadingBtChat = true
            this.loginModal = true
         } else {
            this.chat.open = true
         }
      },

      async getRatingsBike(id) {

         if (id) {
            this.loadingRatings = true

            const ratings = (await SiteService.getBikeRatings(id, this.pagination.perPage, this.pagination.page)).data

            if (ratings) {


               this.ratings = [...this.ratings, ...ratings.ratings];
               this.loadingRatings = false

               this.pagination.total = ratings.total
               this.loadingRatings = false
            } else {
               this.loadingRatings = false
            }
         }


      },

      reportProblemAction(bikeID) {
         let user = {ID: bikeID, owner: this.user.firstName + ' ' + this.user.lastName};
         location.href = 'mailto:contato@pedale.net.br?Subject=Ajuda%20Pedale%20-%20Bicicleta%20#' + user.ID + '%20-%20' + user.owner + ''
      },

      getCover(uri) {
         return BikeImg.getCover(uri);
      },

      getGallery(uri) {
         return BikeImg.getGallery(uri);
      },

      // Algoritmo que verifica se os dados do usuário estão preenchidos.
      isUserCompletedTheRegistration(data) {
         const dataUser = Object.create((data))
         let address = {...dataUser.address}
         let additionalInformation =  {...dataUser.additionalInformation}

         // identifica se o telefone foi verificado.
         const verifiedPhone = additionalInformation.verifiedPhone || false
         // Remove propriedades opcionais
         delete address.complement
         delete additionalInformation.businessName
         delete additionalInformation.corporateName
         delete additionalInformation.dateOfBirth
         delete additionalInformation.type
         delete additionalInformation.verifiedPhone
         delete additionalInformation.gender

         // Verifica se as informações principais estão preenchidas.
         const checkPrincipalInformation = Object.values(additionalInformation).every( f => f || false)

         // Verifica se os dados do endereço estão preenchidos.
         const checkAddress = Object.values(address).every( f => f || false)

         return !verifiedPhone || !checkPrincipalInformation || !checkAddress

      },

      // Obtém o retorno do formulário das informações de endereço e verificação de telefone,
      // popula o orderUserInformation e faz o pedido.
      handleCallBackInfoForm(v) {
         if (v) {
            // isRequestedByOwner
            this.loadingOrderFronModalInfo = true
            this.checkoutModal = false
            this.orderUserInformation.firstName = v.name
            this.orderUserInformation._id = v._id
            this.orderUserInformation.lastName = v.lastName
            this.orderUserInformation.additionalInformation.cpf = v.cpf
            this.orderUserInformation.phone = v.phone
            this.orderUserInformation.verifiedPhone = v.verifiedPhone
            this.orderUserInformation.email = v.email
            this.orderUserInformation.pushToken = v.resources && v.resources.pushToken ? v.resources.pushToken : ''

            this.orderUserInformation.address = {
               street: v.address,
               cep: v.cep,
               city: v.city,
               complement: v.complement,
               district: v.district,
               number: v.number,
               state: v.state,
            }
            this.sendOrder(v._id)
         } else {
            this.$message({
               message: 'Serviço indisponível. Tente novamente mais tarde. Err: handleCallBackInfoForm()',
               type: 'error'
            });
         }

      },

      loginDone(v) {
         if (v) {
            this.loginModal = false
            this.registerModal = false
            this.loadingOrderFronModalInfo = true
            setTimeout(() => {
               this.goCheckout()
            }, 1000)
         }
      },

      goCheckout() {

         this.bike.user = this.user
         this.namespace = 'bike'

         //this.$store.dispatch('bike/storeBike', this.bike);

         this.loadinBtnCheckout = true


         // Se não estiver logado, abre o modal de login
         if (!this.currentUser) {
            this.loginModal = true
         }

         // Se estiver logado e for um ciclista, vai para o fluxo do pedido
         if (this.currentUser && !this.isRequestedByOwner) {
            this.newOrder()
         }

         // Se estiver logado e for um anunciante, abre o modal para selecionar o ciclista
         if (this.currentUser && this.isRequestedByOwner) {
            this.checkoutModal = true
         }

      },

      // Lida com o total do pedido, a ser usado no model do pedido.
      handleTotalOrder() {
         // TOTAL por hora
         if (this.typeOfLeasePeriod === 'perHour' && this.timeNumber > 0 && this.leaseModality === 'onDemand') {
            return this.timeNumber * this.bike.info.timeValue
         }

         // TOTAL por diária
         if (this.typeOfLeasePeriod === 'daily' && this.dailyNumberCalc > 0 && this.leaseModality === 'onDemand') {
            return this.dailyNumberCalc * this.bike.info.dailyValue
         }

         // TOTAL por semana
         if (this.typeOfLeasePeriod === 'perWeek' && this.numberOfRentalWeeks > 0 && this.leaseModality === 'signature') {
            return this.bike.info.weekValue * this.numberOfRentalWeeks
         }

         // TOTAL por mês
         if (this.typeOfLeasePeriod === 'monthly' && this.numberOfMonthsOfLease > 0 && this.leaseModality === 'signature') {
            return this.bike.info.monthValue * this.numberOfMonthsOfLease
         }
      },

      // Obtém as informações atualizadas do usuário antes de efetuar o pedido.
      async getUserInfo() {
         try {
            return await UserService
               .getUserInfoForCheckoutData()
               .then(res => {
                  this.orderUserInformation = {
                     firstName: '',
                     lastName: ''
                  }
                  this.orderUserInformation = res.data.user
                  return(res.data.user)
               })

         } catch (e) {
            this.$message({
               message: 'Serviço indisponível. Tente novamente mais tarde. Err: getUserInfo().UserService()',
               type: 'error'
            });
         }
      },

      // Aciona fluxo de novo pedido
      async newOrder() {
         // Obtém as informações do usuário logado
         const user = await this.getUserInfo()

         if (user) {
            // Verifica informações e, caso alguma informação necessária esteja faltando, abre o modal com o formulário (checkoutModal)
            // Caso contrário, realiza o pedido.
            if (this.isUserCompletedTheRegistration(user)) {
               this.checkoutModal = true
               return false
            } else {
               this.sendOrder()
            }
         }
      },

      // Método para enviar o pedido para a api.
      sendOrder(customerID) {
         const payload = {
            customerID,
            isRequestByOwner: this.isRequestedByOwner,
            bike: this.bike._id,
            amount: this.handleTotalOrder(),
            leaseModality: this.leaseModality,
            typeOfLeasePeriod: this.typeOfLeasePeriod,
            daySelectedForHourlyRental: this.daySelectedForHourlyRental,
            startHourRental: this.startHourRental,
            endHourRental: this.endHourRental,
            numberOfMonthsOfLease: this.numberOfMonthsOfLease,
            numberOfRentalWeeks: this.numberOfRentalWeeks,
            period: {
               checkin: this.selectDatesQuery.dateCheckin || new Date(),
               checkout: this.selectDatesQuery.dateCheckout || new Date(),
            },
            userInfoForm: {
               name: this.orderUserInformation.firstName,
               _id: this.orderUserInformation._id,
               lastName: this.orderUserInformation.lastName,
               cpf: this.orderUserInformation.additionalInformation.cpf,
               cep: this.orderUserInformation.address.cep,
               address: this.orderUserInformation.address.street,
               number: this.orderUserInformation.address.number,
               complement: this.orderUserInformation.address.complement,
               district: this.orderUserInformation.address.district,
               city: this.orderUserInformation.address.city,
               state: this.orderUserInformation.address.state,
               phone: this.orderUserInformation.phone,
               verifiedPhone: this.orderUserInformation.verifiedPhone,
               countryCod: '+55',
               email: this.orderUserInformation.email,
            },
            billingAddress: {
               cep: this.orderUserInformation.address.cep,
               street: this.orderUserInformation.address.street,
               number: this.orderUserInformation.address.number,
               complement: this.orderUserInformation.address.complement,
               district: this.orderUserInformation.address.district,
               city: this.orderUserInformation.address.city,
               state: this.orderUserInformation.address.state,
            },
            resources: {
               pushToken: this.orderUserInformation.pushToken
            }
         }

         OrderService.newOrder(payload)
            .then((response) => {
               setTimeout(() => {
                  this.checkoutModalSuccess = true;
                  this.successOrder = response.data.data;
               }, 1000)

            })
            .finally(() => {
               setTimeout(() => {
                  this.loadinBtnCheckout = false
                  this.loadingOrderFronModalInfo = false
               }, 2000)
            })
      },

      checkStatus() {
         return this.bike.info.status === 1 || this.bike.info.status === 4
      },

      async getMoreRatingsBike(id) {
         this.pagination.page = this.pagination.page + 1
         await this.getRatingsBike(id)
      },

      formatDateChat(date) {
         return this.$moment(date).fromNow()
      },

      closeModalLogin() {
         this.loginModal = false
         this.loadingBtChat = false
         this.loadingOrderFronModalInfo = false
         this.loadinBtnCheckout = false
      },

      closeModalRegister() {
         this.registerModal = false
         this.loadingBtChat = false
         this.loadingOrderFronModalInfo = false
         this.loadinBtnCheckout = false
      },

      handleGoAdviser(id) {
         this.$router.push(`/anunciante/${id}`)
      },

      changeLeasePerMonth(value) {
         this.numberOfMonthsOfLease = value
         this.$store.dispatch('selectDates/setNumberOfMonthsOfLease', value)
      },

      changeRentalPerWeek(value) {
         this.numberOfRentalWeeks = value
         this.$store.dispatch('selectDates/setNumberOfRentalWeeks', value)
      },

      closeModalPreCheckout() {
         this.checkoutModal = false
         this.loadinBtnCheckout = false
         this.orderUserInformation = {
            firstName: '',
               lastName: ''
         }
      },

      hangleChangeDaySelectedForHourlyRental(v) {
         this.$store.dispatch('selectDates/setDaySelectedForHourlyRental', v)
      },

      hangleChangeStartHourRental(v) {
         this.$store.dispatch('selectDates/setStartHourRental', v)
      },

      hangleChangeEndHourRental(v) {
         this.$store.dispatch('selectDates/setEndHourRental', v)
      },

      // usado para lidar com os estados do radio da modalidade da locação e da periodidicadade
      handleRadioState(r) {
         // monthly (mês), perWeek (por semana), daily (por dia) ou perHour (por hora)
         const {  timeValue, dailyValue, weekValue, monthValue } = r

         if (timeValue === 0 && dailyValue === 0) {
            this.leaseModality = 'signature'
         } else if (weekValue === 0 && monthValue === 0) {
            this.leaseModality = 'onDemand'
         }  else {
            this.leaseModality = 'onDemand'
         }

         // por hora
         if (dailyValue === 0 && weekValue === 0 && monthValue === 0) {
            this.typeOfLeasePeriod = 'perHour'
         }

         // por dia
         if (timeValue === 0 && weekValue === 0 && monthValue === 0 || timeValue !== 0 && dailyValue !== 0 && weekValue === 0 && monthValue === 0) {
            this.typeOfLeasePeriod = 'daily'
         }

         // por semana
         if (timeValue === 0 && dailyValue === 0 && monthValue === 0 ) {
            this.typeOfLeasePeriod = 'perWeek'
         }

         // por mês
         if (timeValue === 0 && dailyValue === 0 && weekValue === 0 ) {
            this.typeOfLeasePeriod = 'monthly'
         }

         if (dailyValue === 0 && monthValue ===  0 || dailyValue === 0 && weekValue === 0) {
            this.typeOfLeasePeriod = 'perHour'
         }

         if (timeValue === 0 && monthValue ===  0 || timeValue === 0 && weekValue === 0) {
            this.typeOfLeasePeriod = 'daily'
         }

         if (timeValue && monthValue && weekValue && monthValue) {
            this.typeOfLeasePeriod = 'daily'
         }
      }

   },
   destroyed() {
      this.namespace = ''
   },
   computed: {

      timeNumber: function () {
         return calcTimeNumber(this.startHourRental, this.endHourRental)

      },

      dailyNumberCalc: function () {
         return dailyNumber(this.selectDatesQuery.dateCheckin, this.selectDatesQuery.dateCheckout);
      },

      getFeatures: function () {
         // {"name": "Tipo", "value": "Bike Adulto"},
         let fearureArr = [];
         let obj = this.bike.features;
         let key = '';
         for (let prop in obj) {
            switch (prop) {
               case 'brand':
                  key = 'Marca';
                  break;
               case 'rim':
                  key = 'Aro';
                  break;
               case 'frameSize':
                  if (obj[prop]) {
                     key = 'Tamanho do Quadro';
                     break;
                  } else {
                     continue
                  }
               case 'suspension':
                  key = 'Suspensão';
                  break;
               case 'march':
                  key = 'Marchas';
                  break;
               default:
                  key = prop;
            }

            fearureArr.push({name: key, value: obj[prop]})
         }
         fearureArr.pop();
         return fearureArr;
      },

      searchQuery() {
         return this.$store.state.search.query;
      },
      selectDatesQuery() {
         return this.$store.state.selectDates.dates;
      },
      currentUser() {
         return this.$store.state.auth.user;
      },
   },
   watch: {
      bikeSlug: function (slug) {
         if (slug) {
            SiteService.getBike(slug).then(
               response => {
                  const data = response.data.data;

                  this.handleRadioState(data)
                  this.bike = {
                     _id: data._id,
                     info: {
                        bikeType: data.bikeType,
                        name: data.name,
                        timeValue: data.timeValue,
                        dailyValue: data.dailyValue,
                        weekValue: data.weekValue,
                        monthValue: data.monthValue,
                        description: data.description,
                        rateMetrics: data.rateMetrics,
                        status: data.status,
                        slug: data.slug,
                     },
                     features: data.features,
                     address: data.address,
                     photos: {
                        coverPhoto: (data.coverPhoto ? data.coverPhoto : null),
                        photoGallery: (data.photoGallery ? data.photoGallery : null)
                     },
                     availableDates: data.availableDates,
                     bikeValue: data.bikeValue,
                     user: data.user
                  }

                  this.center = {
                     lat: data.location.coordinates[1],
                     lng: data.location.coordinates[0]
                  }

                  this.markers = [
                        {
                           Id: 1,
                           name: data.address.name,
                           position: {
                              lat: data.location.coordinates[1],
                              lng: data.location.coordinates[0]
                           }
                        },
                  ]

                  this.availableDates = data.availableDates
                  this.receivedData = true;

                  if (data.rented) {
                     this.bike.rented = data.rented

                     //Caso tenha, cria lista de datas, com base na data início e data fim.
                     data.rented.map((v) => {
                        let checkin = this.$moment(v.period.checkin);
                        let checkout = v.period.checkout;
                        let tempArr = []

                        while (!this.$moment(checkin).isSame(this.$moment(checkout).add(1, 'days'))) {
                           checkin = this.$moment(checkin).add(1, 'days')
                           tempArr.push(checkin.format("YYYY-MM-DD"))
                        }

                        this.availableDates = this.availableDates.filter(e => !tempArr.includes(e))

                     })

                  }

                  this.user = data.user;

                  this.bikePhotos.push(this.getCover(this.bike.photos.coverPhoto));
                  let gallery = this.getGallery(this.bike.photos.photoGallery);


                  gallery.forEach((photo) => {
                     this.bikePhotos.push(photo.url)
                  });

                  this.lng = parseFloat(data.location.coordinates[0]);
                  this.lat = parseFloat(data.location.coordinates[1]);

                  this.loading = false

                  if (!!this.checkStatus() && (this.currentUser ? this.currentUser.user._id : null) !== this.user._id) {
                     this.$router.push('/')
                  }

                  if (!bike.info.monthValue
                     && !bike.info.weekValue ||
                     bike.info.monthValue === 0
                     && bike.info.weekValue === 0) {
                     this.typeOfLeasePeriod = 'daily'
                  }

               },
               err => {
                  //this.$message.error(err.response.data.message);
                  if (err.response.data.error === 'bicycleNotFound' ||
                     err.response.data.error === 'invalidId' ||
                     err.response.status === 404
                  ) {
                     this.$router.push('/')
                  }

               }
            );
         }
      },

      //Watcher para popuplar o avatar do Ciclista no perfil.
      'user.avatar': function (n) {
         const imgDir = n.destination;
         if (n.filename) {
            this.avatarUri = `${this.baseUrl}/${imgDir}/${n.filename}`;
         }
      },

      'bike._id': async function (e) {
         if (e) {
            await this.getRatingsBike(e)
         }
      },

      ratings: function (e) {


         if (e.length >= this.pagination.total) {
            this.loadButtonNewComments = true
         }
      },

      currentUser: function (e) {
         if (e.user._id) {
            if (this.namespace === 'bike/chat') {
               this.loginModal = false
               this.registerModal = false
               this.loadingBtChat = false
               this.chat.open = true
            }
         }
      },

      leaseModality: function (e) {
         // Dispacha no store a modalidade da locação, se é para pedir uma bike ou assinar uma bike
         this.$store.dispatch('selectDates/setLeaseModality', e);

         // Faz a limpeza nos campos, conforme a seleções.
         if (e === 'signature') {
            //this.typeOfLeasePeriod = 'monthly'
            this.$store.dispatch('selectDates/clearDates');
            this.daySelectedForHourlyRental = ''
            this.startHourRental = ''
            this.endHourRental = ''
         }
         if (e === 'onDemand') {
            this.numberOfMonthsOfLease = 1
            this.numberOfRentalWeeks = 1
         }
      },

      typeOfLeasePeriod: function (e) {
         // Dispacha no store o tipo da locação, se é por mês, semana, dia ou hora
         this.$store.dispatch('selectDates/setTypeOfLeasePeriod', e)

         // Faz a limpeza nos campos, conforme a seleções.
         if (e === 'perHour') {
            this.numberOfMonthsOfLease = 0
            this.numberOfRentalWeeks = 0
            this.$store.dispatch('selectDates/clearDates');
         }

         if (e === 'daily') {
            this.numberOfMonthsOfLease = 0
            this.numberOfRentalWeeks = 0
            this.daySelectedForHourlyRental = ''
            this.startHourRental = ''
            this.endHourRental = ''
         }

         if (e === 'perWeek') {
            this.numberOfMonthsOfLease = 0
            this.numberOfRentalWeeks = 1
         }
         if (e === 'monthly') {
            this.numberOfMonthsOfLease = 1
            this.numberOfRentalWeeks = 0
         }
      }
   }
}
</script>

<style lang="scss">
.b-aspect {
   height: 100%;
}

.modal-checkout {
   .el-dialog {
      border-radius: 9px;
   }
   .el-dialog__headerbtn {
      top: 14px;
   }
   .el-dialog__body  {
      padding: 0 0 30px 0;
   }
   .el-dialog__header{
      padding: 0;
   }

   #registerForm {
      padding: 0 30px 0;
   }

   @media screen and (min-width: 1600px) {
      .register {
         width: 50% !important;
      }
   }
}

.el-picker-panel__body-wrapper {
   .available.today {
      border: 1px solid #47b54c;
   }
}

@media screen and (min-width: 767px) {
   .bike-description {
      .container {
         padding: 0 31px;
         margin-top: 0 !important;
         .row {
            padding: 30px 20px;
            border-radius: 10px !important;
         }
      }
   }
}

.bike-description {
   border-radius: 0 !important;
   .container {
      margin-top: 30px;
      .row {
         padding-top: 20px;
         padding-bottom: 20px;
         background: #fff;
         border-radius: 10px 10px 0 0;
      }
   }

   pre {
      font-family: inherit;
      line-height: 19px;
      overflow: hidden;
      margin-bottom: 25px;
      margin-top: 15px;
   }
}

.chat-pedale {
   .btn-chat {
      height: 66px;
   }

   .upload-file-chat {
      bottom: 54px;
      right: 34%;
   }
}

.time-select-range {
   .el-date-editor {
      input {
         padding: 0 0 0 30px;
      }
   }
}

.row-bike {
   .el-loading-mask {
      border-radius: 10px;
   }
}
</style>
